import type { JSONSchema7 } from 'json-schema';

export function getDefaultSchema(): JSONSchema7 {
  return {
    title: '',
    type: 'object',
    properties: {},
  };
}
